import { facadeApi } from 'api'

export const fetchIntercomData = () => facadeApi.get<{ userHash: string }>('/users/me/intercom-data')
